/* eslint-disable no-console */
import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  if ('serviceWorker' in navigator){
    register(`${process.env.BASE_URL}service-worker.js`, {
      ready () {

      },
      registered () {
        //console.log('Service worker has been registered.');
      },
      cached () {
      },
      updatefound () {
      },
      updated () {
      },
      offline () {
      },
      error () {
        //console.error('Error during service worker registration:', error)
      }
    })

  }
}